import React from 'react';
import DataStore from '../flux/stores/DataStore.js';
import Layout from './layout.js';
import {Link} from 'react-router-dom';
import Footer from './footer.js';
import ImageSlider from './image-slider.js';
// import logo from '../../svg/logo-minimal.svg';
import MoldLogo from '../../svg/mold-logo.js';
import ProjectGrid from './project-grid.js';

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile: false
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    // this.scrollCnt = document.querySelector('.App > div > div');
    // window.addEventListener('scroll', this.handleScroll);
    document.body.classList.remove('home-logo-hidden');
    document.body.classList.remove('transparent-header');
    window.addEventListener('resize', this.handleResize);
    window.dispatchEvent(new Event('resize'));
    // console.log(this.scrollCnt);
    this.lockScrolling();
  }

  componentWillUnmount() {
    // window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    document.body.classList.remove('hide-intro');
    this.unlockScrolling();
  }

  handleResize = () => {
    if(window.innerWidth <= 900) {
      console.log('mobile gallery');
      this.setState({
        isMobile: true
      });
    } else {
      console.log('desktop gallery');
      this.setState({
        isMobile: false
      });
    }
  }

  handleScroll(e) {
    // if(window.scrollY > 100) {
    //   document.body.classList.add('home-logo-hidden');
    // }else{
    //   document.body.classList.remove('home-logo-hidden');
    // }
    //
    // if(window.scrollY > window.innerHeight) {
    //   document.body.classList.add('transparent-header');
    // }else{
    //   document.body.classList.remove('transparent-header');
    // }
  }

  hideIntro = () => {
    document.body.classList.add('hide-intro');
    this.unlockScrolling();
  }

  lockScrolling = () => {
    let html = document.body.parentNode,
        body = document.body,
        initWidth = body.offsetWidth,
        initHeight = body.offsetWidth,
        scrollPosition,
        marginR,
        marginB,
        style = window.getComputedStyle(html);

    scrollPosition = [
        window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
        window.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop
    ];

		html.dataset.scrollPosition = scrollPosition;
		html.dataset.previousOverflowY = style.getPropertyValue('overflow-y');
		html.style.overflowY = 'hidden';
    window.scrollTo(scrollPosition[0], scrollPosition[1]);
    marginR = body.outerWidth-initWidth;
    marginB = body.outerHeight-initHeight;
    body.style.marginRight = marginR + 'px';
    body.style.marginBottom = marginB + 'px';
    }

  unlockScrolling = () => {
    console.log('unlocking scrolling');
    let html = document.body.parentNode,
        body = document.body,
        scrollPosition;

    html.style.overflowY = html.dataset.previousOverflowY;
    scrollPosition = html.dataset.scrollPosition;
    window.scrollTo(scrollPosition[0], scrollPosition[1]);
    body.style.marginRight = 0;
    body.style.marginBottom = 0;
  }

  render() {
    const home = DataStore.getPageBySlug('home');

    return (
      <div>
        <Layout>
          <Link to="/" className="home-logo"><MoldLogo /></Link>
          {home.acf.video_mp4.length > 0 ?
          <section id="home-video" className="home-video bg-video-cnt mold-big-logo" onClick={this.hideIntro}>
            <video autoPlay loop muted className="bg-video" poster={home.acf.video_poster}>
              <source src={home.acf.video_mp4} type="video/mp4" />
              {home.acf.video_webm ?
              <source src={home.acf.video_webm} type="video/webm" />:null
              }
              {home.acf.video_ogv ?
              <source src={home.acf.video_ogv} type="video/ogg" />:null
              }
            </video>
          </section>:
          <section id="home-slider" className="home-slider mold-big-logo" onClick={this.hideIntro}>
            {!this.state.isMobile ?
              <ImageSlider slides={home.acf.home_slideshow} />:<ImageSlider slides={home.acf.home_slideshow_mobile} />
            }
          </section>
          }
          <ProjectGrid />
        </Layout>
        <Footer footerClass="home" />
      </div>
      );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/scripts/components/home.js